import { Tag } from 'antd';
import { companyColors, companyOptions } from 'apps/investment/constants';
import { fundDistributorsOptions } from 'apps/investment/constants/fund-distributors';
import {
  fundOrderSideColors,
  fundOrderSideLabels,
  fundOrderSideOptions,
} from 'apps/investment/constants/fund-orders';
import {
  orderProgramTypeColors,
  orderProgramTypeLabels,
  orderStatusColors,
} from 'apps/investment/constants/fundOrder';
import { DataTableColumnHeader } from 'common/data-table-column-header';
import { FilterFieldConfig } from 'common/dynamic-filter-form';
import {
  dateTimeCell,
  linkCell,
  numberCell,
  userCell,
} from 'utils/cell-formatter';

export const columnsGenerator = () => [
  {
    accessorKey: 'id',
    header: '',
    cell: ({ getValue }) =>
      linkCell({ getValue, path: '/investment/fund-orders' }),
  },

  {
    accessorKey: 'order_date',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Order Date" />
    ),
    cell: dateTimeCell,
  },
  {
    accessorKey: 'order_source',
    header: 'Nguồn',
    cell: ({ getValue }) => {
      const value = getValue();
      return <Tag color={companyColors[value]}>{value}</Tag>;
    },
  },
  {
    header: 'Lệnh',
    accessorKey: 'order_side',
    cell: ({ getValue }) => {
      const value = getValue();
      return (
        <Tag color={fundOrderSideColors[value]}>
          {fundOrderSideLabels[value] || value}
        </Tag>
      );
    },
  },
  {
    header: 'Program',
    accessorKey: 'program_type',
    cell: ({ getValue }) => {
      const value = getValue();
      return (
        <Tag color={orderProgramTypeColors[value]}>
          {orderProgramTypeLabels[value]}
        </Tag>
      );
    },
  },
  {
    header: 'Trạng thái',
    accessorKey: 'status',
    cell: ({ row, getValue }) => {
      const status = getValue();
      const label = row.original.status_label;
      return <Tag color={orderStatusColors[status]}>{label}</Tag>;
    },
  },
  {
    header: 'Amount',
    accessorKey: 'amount',
    cell: numberCell,
  },
  {
    header: 'Quantity',
    accessorKey: 'quantity',
    cell: numberCell,
  },

  {
    header: 'Fund Order ID',
    accessorKey: 'fund_order_id',
  },
  {
    header: 'Product Code',
    accessorKey: 'fund_code',
  },
  {
    header: 'Nhà phân phối',
    accessorKey: 'trading_account_manager',
    cell: ({ getValue }) => {
      const value = getValue();
      return <Tag color={companyColors[value]}>{value}</Tag>;
    },
  },
  {
    header: 'User',
    accessorKey: 'user',
    cell: userCell,
  },
  {
    accessorKey: 'created_at',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Created" />
    ),
    cell: dateTimeCell,
  },

  {
    accessorKey: 'updated_at',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Updated" />
    ),
    cell: dateTimeCell,
  },
];

export const filterConfig: FilterFieldConfig[] = [
  {
    name: 'order_side',
    type: 'select',
    label: 'Order Side',
    placeholder: 'All',
    minWidth: '120px',
    options: fundOrderSideOptions,
    defaultValue: 'all',
  },
  {
    name: 'status',
    type: 'select',
    label: 'Trạng thái',
    placeholder: 'All',
    minWidth: '120px',
    options: [
      { value: '0', label: 'Mới tạo' },
      { value: '1', label: 'Chờ thanh toán/xác nhận' },
      { value: '2', label: 'Chờ VSD duyệt' },
      { value: '3', label: 'VSD đã duyệt - Chờ khớp' },
      { value: '4', label: 'Đã khớp - Chờ phân phối' },
      { value: '5', label: 'Đã phân phối' },
      { value: '6', label: 'Đã hủy' },
      { value: '-1', label: 'Đang xử lý' },
    ],
    defaultValue: 'all',
  },
  {
    name: 'order_source',
    type: 'select',
    label: 'Nguồn',
    placeholder: 'All',
    minWidth: '120px',
    options: companyOptions,
    defaultValue: 'all',
  },
  {
    name: 'program_type',
    type: 'select',
    label: 'Program',
    placeholder: 'All',
    minWidth: '120px',
    options: [
      { value: '1002', label: 'Flex' },
      { value: '1003', label: 'Trade' },
    ],
    defaultValue: 'all',
  },
  {
    name: 'trading_account_manager',
    type: 'select',
    label: 'Nhà phân phối',
    placeholder: 'All',
    minWidth: '120px',
    options: fundDistributorsOptions,
    defaultValue: 'all',
  },
];
